// src/store/callActionsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  callStatus: 'idle',
  isScreenSharing: false,
  incall: [],
  receiverId: null,
};

const callActionsSlice = createSlice({
  name: 'callActions',
  initialState,
  reducers: {
    acceptCall(state, action) {
      state.callStatus = 'active';
      state.incall = [...state.incall, action.payload.senderId, action.payload.receiverId];
      state.receiverId = action.payload.receiverId;
    },
    endCall(state) {
      state.callStatus = 'idle';
      state.isScreenSharing = false;
      state.incall = [];
      state.receiverId = null;
    },
    toggleScreenShare(state, action) {
      state.isScreenSharing = action.payload;
    },
  },
});

export const { acceptCall, endCall, toggleScreenShare } = callActionsSlice.actions;

export default callActionsSlice.reducer;